/* eslint-disable @typescript-eslint/no-explicit-any */
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { CategoryModel } from '@mercadoni/sinister/dist/lib/src/entities/category'
import { FC } from 'react'
import { useHeaderContext } from '../../contexts/HeaderContext'

interface CategoriesLogicProps {
  Wrapper: FC<any>
  className?: string
  initialCategories?: CategoryModel[]
}

const CategoriesLogic: FC<CategoriesLogicProps> = ({
  Wrapper,
  className,
  initialCategories,
}) => {
  const {
    locale: clientLocale,
    clientId,
    categoryTree: clientCategoryTree,
  } = UseClientModelContext()

  const {
    onCategoryOnClick,
    onPromotionsOnClick,
    store,
    copies,
    isLightBackground,
    isMobile,
  } = useHeaderContext()

  return (
    <Wrapper
      clientLocale={clientLocale}
      clientId={clientId}
      clientCategoryTree={clientCategoryTree}
      className={className}
      initialCategories={initialCategories}
      onCategoryOnClick={onCategoryOnClick}
      onPromotionsOnClick={onPromotionsOnClick}
      store={store}
      copies={copies}
      isLightBackground={isLightBackground}
      isMobile={isMobile}
    />
  )
}

export default CategoriesLogic
